var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgModeEdit(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.99805 21.001H6.74805L17.808 9.94103L14.058 6.19104L2.99805 17.251V21.001ZM4.99805 18.081L14.058 9.02104L14.978 9.94103L5.91805 19.001H4.99805V18.081Z",
    fill: "#00467F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.368 3.29104C17.978 2.90104 17.348 2.90104 16.958 3.29104L15.128 5.12104L18.878 8.87104L20.708 7.04104C21.098 6.65104 21.098 6.02104 20.708 5.63104L18.368 3.29104Z",
    fill: "#00467F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgModeEdit);
export default __webpack_public_path__ + "static/media/mode_edit.fc8c5bb9d4e0356fb0f819c64d117496.svg";
export { ForwardRef as ReactComponent };